import React, { useEffect, useState } from "react";
import { EmailAnalysisBranch } from "@types";
import { AuthorityZone } from "@taskpane/components";
import css from "./WizardAuthorityZoneResult.module.scss";

export interface WizardAuthorityZoneResultProps {
  currentScore: number;
  selectedBranch: EmailAnalysisBranch | null;
}

const WizardAuthorityZoneResult: React.FC<WizardAuthorityZoneResultProps> = ({
  currentScore,
  selectedBranch,
}) => {
  const [currentBranch, setCurrentBranch] = useState<EmailAnalysisBranch | null>(
    selectedBranch || null
  );

  const text =
    "The new draft will strengthen your position in the Authority Zone and make it more robust than the previous version.";
  const attrs = {
    container: {
      className: css.container,
    },
    authorityZone: {
      currentScore,
      selectedBranch: currentBranch,
      selectedEmail: currentBranch?.draft || null,
      isDraft: true,
      isSimplified: true,
    },
  };

  useEffect(() => {
    if (selectedBranch) {
      setCurrentBranch(selectedBranch);
    }
  }, [selectedBranch]);

  return (
    <div {...attrs.container}>
      <span>{text}</span>
      <AuthorityZone {...attrs.authorityZone} />
    </div>
  );
};

export default WizardAuthorityZoneResult;
